module.exports = __webpack_public_path__ + "68a1e2dad267d5b2bf1df6caea38cfa9.pdf";